// extracted by mini-css-extract-plugin
export default {"carouselpos":"CarouselHome_carouselpos__rzl74","carouselScroll":"CarouselHome_carouselScroll__oLYtH"};